import { EnvironmentProviders, Provider } from '@angular/core';
import { abiosConfigName } from '@bcf-v2-configurators/tokens/abios/lvbet/abios-config-name';
import { ABIOS_CONFIG_NAME } from '@bcf-v2-configurators/tokens/abios/token';
import { campaignIdsWithExpirationDate } from '@bcf-v2-configurators/tokens/affiliate/lvbetpl/affiliate-ids-with-expiration-date';
import { CAMPAIGN_IDS_WITH_EXPIRATION_DATE } from '@bcf-v2-configurators/tokens/affiliate/token';
import { QUICK_BLIK_IN_BETSLIP_ENABLED } from '@bcf-v2-configurators/tokens/betslip/token';
import { cmsSitesLinksMapper } from '@bcf-v2-configurators/tokens/cms-sites-links-mapper/lvbetpl/cms-sites-links-mapper';
import { CMS_SITES_LINKS_MAPPER } from '@bcf-v2-configurators/tokens/cms-sites-links-mapper/token';
import { COOKIE_CONSENT_GAMBLING_ADULT_LOADER } from '@bcf-v2-configurators/tokens/cookie-consent/token';
import { dateFnsI18n } from '@bcf-v2-configurators/tokens/date-fns-i18n/lvbetpl/date-fns-i18n';
import { DATE_FNS_I18N } from '@bcf-v2-configurators/tokens/date-fns-i18n/token';
import { resultCenterDateFormat } from '@bcf-v2-configurators/tokens/date-format/lvbetpl/results-center-date-format';
import { RESULT_CENTER_DATE_FORMAT } from '@bcf-v2-configurators/tokens/date-format/token';
import { defaultLang } from '@bcf-v2-configurators/tokens/default-lang/lvbetpl/default-lang';
import { DEFAULT_LANG } from '@bcf-v2-configurators/tokens/default-lang/token';
import { I18N_OPTIMOVE_DESC_LOADER } from '@bcf-v2-configurators/tokens/descs-optimove-i18n/token';
import { I18N_DESC_LOADER } from '@bcf-v2-configurators/tokens/descs/token';
import { editProfileAddressAvailableFieldsFn } from '@bcf-v2-configurators/tokens/edit-profile/lvbetcom/edit-profile-available-fields';
import { editProfilePrivacyAndNotificationsShowContactSupportInfo } from '@bcf-v2-configurators/tokens/edit-profile/lvbetpl/edit-profile-privacy-and-notifications-show-contact-support-info';
import { editProfileShowBankAccountInfo } from '@bcf-v2-configurators/tokens/edit-profile/lvbetpl/edit-profile-show-bank-account-info';
import { editProfileShowContactSupportInfo } from '@bcf-v2-configurators/tokens/edit-profile/lvbetpl/edit-profile-show-contact-support-info';
import {
  EDIT_PROFILE_ADDRESS_AVAILABLE_FIELDS,
  EDIT_PROFILE_PRIVACY_AND_NOTIFICATIONS_SHOW_CONTACT_SUPPORT_INFO,
  EDIT_PROFILE_SHOW_BANK_ACCOUNT_INFO,
  EDIT_PROFILE_SHOW_CONTACT_SUPPORT_INFO
} from '@bcf-v2-configurators/tokens/edit-profile/token';
import { footerBrandName } from '@bcf-v2-configurators/tokens/footer/lvbetpl/footer-brand-name';
import { footerLinksFn } from '@bcf-v2-configurators/tokens/footer/lvbetpl/footer-links';
import { spSidebarLinksFn } from '@bcf-v2-configurators/tokens/footer/lvbetpl/sp-sidebar-links';
import { FOOTER_BRAND_NAME, FOOTER_LINKS, SP_SIDEBAR_LINKS } from '@bcf-v2-configurators/tokens/footer/token';
import { GOOGLE_LOCALES_MAP_CONFIG_LOADER } from '@bcf-v2-configurators/tokens/google-locales-map/token';
import { imgWebConfig } from '@bcf-v2-configurators/tokens/img-webp/lvbetpl/img-web-config';
import { IMG_WEB_CONFIG } from '@bcf-v2-configurators/tokens/img-webp/token';
import { introBonusesTabHighlighted } from '@bcf-v2-configurators/tokens/intro/lvbetpl/intro-bonuses-tab-highlighted';
import { INTRO_BONUSES_TAB_HIGHLIGHTED } from '@bcf-v2-configurators/tokens/intro/token';
import { lotteryBrandName } from '@bcf-v2-configurators/tokens/lottery/lvbet/lottery-brand-name';
import { LOTTERY_BRAND_NAME } from '@bcf-v2-configurators/tokens/lottery/token';
import { lotteryAssetsUrlValue } from '@bcf-v2-configurators/tokens/lv-wheel/lvbetpl/lottery-assets-url';
import { lvWheelConfig } from '@bcf-v2-configurators/tokens/lv-wheel/lvbetpl/lv-wheel-config';
import { LV_WHEEL_CONFIG } from '@bcf-v2-configurators/tokens/lv-wheel/token';
import { lvisionBetBoosterApiKeys } from '@bcf-v2-configurators/tokens/lvision-bet-booster/lvbetpl/lvision-bet-booster-api-keys';
import { LVISION_BET_BOOSTER_API_KEYS } from '@bcf-v2-configurators/tokens/lvision-bet-booster/token';
import { mobileApplicationAppConfig } from '@bcf-v2-configurators/tokens/mobile-application/sportsbook/lvbetpl/config';
import { MOBILE_APPLICATION_APPS_CONFIG } from '@bcf-v2-configurators/tokens/mobile-application/token';
import { modalCookiesShowIndicator } from '@bcf-v2-configurators/tokens/modals/lvbetcom/modal-cookies-show-indicator';
import { MODAL_COOKIES_INDICATOR } from '@bcf-v2-configurators/tokens/modals/token';
import { commonTaxPayoutDetailsInfo } from '@bcf-v2-configurators/tokens/my-bets/lvbetpl/common-tax-payout-details-info';
import { customTaxPayoutDetailsInfo } from '@bcf-v2-configurators/tokens/my-bets/lvbetpl/custom-tax-payout-details-info';
import {
  COMMON_TAX_PAYOUT_DETAIL_INFO,
  CUSTOM_TAX_PAYOUT_DETAIL_INFO
} from '@bcf-v2-configurators/tokens/my-bets/token';
import { OPTIMOVE_SDK_CONFIG_LOADER } from '@bcf-v2-configurators/tokens/optimove-sdk/tokens';
import { PUSH_NOTIFICATIONS_CONFIG_LOADER } from '@bcf-v2-configurators/tokens/push-notifications/token';
import { registerIntroBannerId } from '@bcf-v2-configurators/tokens/register/lvbetpl/register-intro-banner-id';
import { registerIntroForceRegisterSelection } from '@bcf-v2-configurators/tokens/register/lvbetpl/register-intro-force-register-selection';
import {
  REGISTER_INTRO_BANNER_ID,
  REGISTER_INTRO_FORCE_REGISTER_SELECTION
} from '@bcf-v2-configurators/tokens/register/token';
import { rgTakeBreakCustomSelfExclusionMessageFn } from '@bcf-v2-configurators/tokens/rg-take-break/lvbetpl/rg-take-break-custom-self-exclusion-message';
import { RG_TAKE_BREAK_CUSTOM_SELF_EXCLUSION_MESSAGE_FN } from '@bcf-v2-configurators/tokens/rg-take-break/token';
import { sportsImagesAssetsUrl } from '@bcf-v2-configurators/tokens/sports/lvbetpl/sports-images-assets-url';
import { SPORTS_IMAGES_ASSETS_URL } from '@bcf-v2-configurators/tokens/sports/token';
import { statscoreVizuConfig } from '@bcf-v2-configurators/tokens/statscore-vizu-config/lvbet/statscore-vizu-config';
import { STATSCORE_VIZU_CONFIG } from '@bcf-v2-configurators/tokens/statscore-vizu-config/token';
import { bonusCustomName } from '@bcf-v2-configurators/tokens/user-bonuses/lvbetpl/bonus-custom-name';
import { bonusesFreeSpinsEnabled } from '@bcf-v2-configurators/tokens/user-bonuses/lvbetpl/bonuses-free-spins-enabled';
import { BONUS_CUSTOM_NAME, BONUSES_FREE_SPINS_ENABLED } from '@bcf-v2-configurators/tokens/user-bonuses/token';
import { wizardPostFormHiddenFields } from '@bcf-v2-configurators/tokens/wizard-post/curacao/wizard-form-post-hidden-fields';
import { wizardPostFormLayoutConfig } from '@bcf-v2-configurators/tokens/wizard-post/curacao/wizard-post-form-layout-config';
import {
  WIZARD_POST_FORM_HIDDEN_FIELDS,
  WIZARD_POST_FORM_LAYOUT_CONFIG
} from '@bcf-v2-configurators/tokens/wizard-post/token';
import { provideVanillaTsTokens } from '@bcf-v2-shared/misc/vanilla-ts-providers/provide-vanilla-ts-tokens';
import { logRocketApiKey } from '@bcf-vanilla-ts-v1-configurators/tokens/log-rocket/lvbetpl/log-rocket-api-key';
import { registerLogRocketApiKey } from '@bcf-vanilla-ts-v1-configurators/tokens/log-rocket/token';
import { LOTTERY_ASSETS_URL } from '@bcf-vanilla-ts-v1-configurators/tokens/lottery/token';
import { registerDiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

export const settingsProviders: (Provider | EnvironmentProviders)[] = [
  provideVanillaTsTokens(() => {
    registerDiToken(CMS_SITES_LINKS_MAPPER, () => cmsSitesLinksMapper);
  }),
  {
    provide: IMG_WEB_CONFIG,
    useValue: imgWebConfig
  },
  {
    provide: DEFAULT_LANG,
    useValue: defaultLang
  },
  {
    provide: LV_WHEEL_CONFIG,
    useValue: lvWheelConfig
  },
  {
    provide: I18N_DESC_LOADER,
    useValue: () =>
      import(
        /* webpackChunkName: "const-i18n-desc" */ '@bcf-v2-configurators/tokens/descs/lvbetpl/mobile-web/i18n-descs'
        // eslint-disable-next-line @typescript-eslint/typedef
      ).then((mod) => mod.i18nDesc)
  },
  {
    provide: EDIT_PROFILE_ADDRESS_AVAILABLE_FIELDS,
    useValue: editProfileAddressAvailableFieldsFn
  },
  {
    provide: EDIT_PROFILE_PRIVACY_AND_NOTIFICATIONS_SHOW_CONTACT_SUPPORT_INFO,
    useValue: editProfilePrivacyAndNotificationsShowContactSupportInfo
  },
  {
    provide: EDIT_PROFILE_SHOW_CONTACT_SUPPORT_INFO,
    useValue: editProfileShowContactSupportInfo
  },
  {
    provide: EDIT_PROFILE_SHOW_BANK_ACCOUNT_INFO,
    useValue: editProfileShowBankAccountInfo
  },
  {
    provide: RG_TAKE_BREAK_CUSTOM_SELF_EXCLUSION_MESSAGE_FN,
    useValue: rgTakeBreakCustomSelfExclusionMessageFn
  },
  {
    provide: MOBILE_APPLICATION_APPS_CONFIG,
    useValue: mobileApplicationAppConfig
  },
  {
    provide: STATSCORE_VIZU_CONFIG,
    useValue: statscoreVizuConfig
  },
  {
    provide: ABIOS_CONFIG_NAME,
    useValue: abiosConfigName
  },
  {
    provide: WIZARD_POST_FORM_LAYOUT_CONFIG,
    useValue: wizardPostFormLayoutConfig
  },
  {
    provide: WIZARD_POST_FORM_HIDDEN_FIELDS,
    useValue: wizardPostFormHiddenFields
  },
  {
    provide: BONUS_CUSTOM_NAME,
    useValue: bonusCustomName
  },
  {
    provide: BONUSES_FREE_SPINS_ENABLED,
    useValue: bonusesFreeSpinsEnabled
  },
  {
    provide: FOOTER_LINKS,
    useValue: footerLinksFn
  },
  {
    provide: SP_SIDEBAR_LINKS,
    useValue: spSidebarLinksFn
  },
  {
    provide: FOOTER_BRAND_NAME,
    useValue: footerBrandName
  },
  {
    provide: PUSH_NOTIFICATIONS_CONFIG_LOADER,
    useValue: () =>
      import('@bcf-v2-configurators/tokens/push-notifications/lvbetpl/push-notifications-config').then(
        // eslint-disable-next-line @typescript-eslint/typedef
        (mod) => mod.pushNotificationsConfigs
      )
  },
  {
    provide: DATE_FNS_I18N,
    useValue: dateFnsI18n
  },
  {
    provide: GOOGLE_LOCALES_MAP_CONFIG_LOADER,
    useValue: () =>
      import('@bcf-v2-configurators/tokens/google-locales-map/lvbetpl/google-locales-map-config').then(
        // eslint-disable-next-line @typescript-eslint/typedef
        (mod) => mod.googleMapsLocalesConfig
      )
  },
  {
    provide: OPTIMOVE_SDK_CONFIG_LOADER,
    useValue: () =>
      import('@bcf-v2-configurators/tokens/optimove-sdk/lvbetpl/mobile-web/optimove-sdk-config').then(
        // eslint-disable-next-line @typescript-eslint/typedef
        (mod) => mod.optimoveSdkConfigs
      )
  },
  {
    provide: I18N_OPTIMOVE_DESC_LOADER,
    useValue: () =>
      import('@bcf-v2-configurators/tokens/descs-optimove-i18n/lvbetpl/sportsbook/i18n-optimove-desc').then(
        // eslint-disable-next-line @typescript-eslint/typedef
        (mod) => mod.i18nOptimoveDesc
      )
  },
  {
    provide: QUICK_BLIK_IN_BETSLIP_ENABLED,
    useValue: true
  },
  {
    provide: LVISION_BET_BOOSTER_API_KEYS,
    useValue: lvisionBetBoosterApiKeys
  },
  {
    provide: COMMON_TAX_PAYOUT_DETAIL_INFO,
    useValue: commonTaxPayoutDetailsInfo
  },
  {
    provide: CUSTOM_TAX_PAYOUT_DETAIL_INFO,
    useValue: customTaxPayoutDetailsInfo
  },
  {
    provide: RESULT_CENTER_DATE_FORMAT,
    useValue: resultCenterDateFormat
  },
  {
    provide: LOTTERY_ASSETS_URL,
    useValue: lotteryAssetsUrlValue
  },
  {
    provide: CAMPAIGN_IDS_WITH_EXPIRATION_DATE,
    useValue: campaignIdsWithExpirationDate
  },
  {
    provide: COOKIE_CONSENT_GAMBLING_ADULT_LOADER,
    useValue: () =>
      import(
        /* webpackChunkName: "const-cookie-consent-gambling-adult" */ '@bcf-v2-configurators/tokens/cookie-consent/projects/sportsbook/lvbetpl/cookie-consent-gambling-adult'
        // eslint-disable-next-line @typescript-eslint/typedef
      ).then((mod) => mod.cookieConsentGamblingAdult)
  },
  {
    provide: MODAL_COOKIES_INDICATOR,
    useValue: modalCookiesShowIndicator
  },
  {
    provide: LOTTERY_BRAND_NAME,
    useValue: lotteryBrandName
  },
  provideVanillaTsTokens(() => {
    registerLogRocketApiKey(logRocketApiKey);
  }),
  {
    provide: SPORTS_IMAGES_ASSETS_URL,
    useValue: sportsImagesAssetsUrl
  },
  {
    provide: INTRO_BONUSES_TAB_HIGHLIGHTED,
    useValue: introBonusesTabHighlighted
  },
  {
    provide: REGISTER_INTRO_BANNER_ID,
    useValue: registerIntroBannerId
  },
  {
    provide: REGISTER_INTRO_FORCE_REGISTER_SELECTION,
    useValue: registerIntroForceRegisterSelection
  }
];
